<template>
  <NavBar  pageName="MsisdnsClasses"></NavBar>
  <v-snackbar
      v-model="snackbarVisible"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
  >
    {{ snackbarMessage }}
    <template v-slot:action>
      <v-btn text color="red" @click="snackbarVisible = false">Close</v-btn>
    </template>
  </v-snackbar>
  <YesNoNotification v-if="openYesNoNotification"
                     :title="'Delete Record'"
                     :message="'Are you sure you want to delete this record?'"
                     @onYesEvent=" fetchDeleteMsisdnClass"
                     @onNoEvent=" fetchCancelDeleteMsisdnClass"
  />
  <v-container name="MSISDN Classes" style="margin-top: 185px;">
    <v-btn variant="text" size="small" @click="$router.push('/settings/msisdn')" class="mb-2">
      <v-icon size="small" class="mr-1">mdi-arrow-left</v-icon>
      MSISDN Settings
    </v-btn>
    <v-card>
      <v-card-title>
        MSISDN Classes
      </v-card-title>
      <v-card-subtitle>
        <v-btn
            color="primary"
            @click="addNewMsisdnClass()"
        >
          Add new Msisdn Class
        </v-btn>
      <v-btn
          class="ml-4"
            color="primary"
            @click="goToSettings()"
        >
          Settings

        </v-btn>
      </v-card-subtitle>
      <v-card-text>
      <v-data-table
          :headers="headers"
          :items="msisdnClasses"
          item-value="id"
          class="elevation-1"
          :items-per-page="100"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>MSISDN Classes</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="fetchMsisdnClasses">Refresh</v-btn>
          </v-toolbar>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-btn
              color="primary"
              @click="editMsisdnClass(item)"
          >
            Edit
          </v-btn>
        <v-btn
            class="ml-2"
              color="error"
              @click="handleDeleteMsisdnClass(item)"
          >
            Delete
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>

  <!-- Conditional rendering of the editor -->
    <v-dialog v-model="isEditing" max-width="600px">
      <MsisdnClassEditor  v-model="isEditing" max-width="600px"
                          :selectedMsisdnClass="selectedMsisdnClass"
                          :token="token"
                          @MsisdnClassSavedEvent="handleUpdateSuccess"
                          @reset-form="loadOriginalData"
      />
    </v-dialog>

    <v-dialog v-model="showAddNewMsisdnClass" max-width="600px">
      <AddNewMsisdnClassEditor   max-width="600px"
                                :token="token"
                                @MsisdnClassSavedEvent="closeAddNewMsisdnClass"
                                @MsisdnClassResetEvent="closeAddNewMsisdnClass"

      />
    </v-dialog>



  </v-container>


</template>

<script>
import MsisdnClassEditor from "@/components/MsisdnClassEditor.vue";
import useGetLoggedIn from "@/composables/useGetLoggedIn";
import {log} from "@/composables/useLog";
import useGetMsisdnsAPIs from "@/composables/useGetMsisdnsAPIs";
import NavBar from "@/components/NavBar.vue";
import YesNoNotification from "@/components/YesNoNotification.vue";
import AddNewMsisdnClassEditor from "@/components/AddNewMsisdnClassEditor.vue";
export default {
  components: {AddNewMsisdnClassEditor, YesNoNotification, NavBar, MsisdnClassEditor },
  data() {
    return {
      msisdnClasses: [],
      selectedMsisdnClass: null,
      isEditing: false,
      openYesNoNotification:false,
      showAddNewMsisdnClass:false,
      openYesNoNotificationCallback:null,
      headers: [
        { title: "ID", key: "id" },
        { title: "Class ID", key: "msisdn_class_id" },
        { title: "Name", key: "name" },
        { title: "Class Example", key: "class_example" },
        { title: "Active", key: "active" },
        { title: "Busy", key: "count_busy" },
        { title: "Available", key: "count_available" },
        { title: "Actions", key: "action", sortable: false },
      ],
      snackbarVisible: false, // Controls visibility of the Snackbar
      snackbarMessage: "", // Message to display in the Snackbar
      snackbarColor: "success", // Color of the Snackbar ("success", "error", etc.)
      snackbarTimeout: 1500, // Timeout in milliseconds (how long it will stay visible)
    };
  },
  methods: {
    showSnackbar(message, color) {
      this.snackbarMessage = message;
      this.snackbarColor = color;
      this.snackbarVisible = true;
    },
    goToSettings(){
      this.$router.replace({
        name: "settings"
      });
    },

    async addNewMsisdnClass() {
      this.showAddNewMsisdnClass=true
    },
    loadOriginalData(){
      this.closeEditor();
      this.fetchMsisdnClasses()
    },
    async fetchMsisdnClasses() {
      // alert("reread MsisdnsClasses")
      const {getMsisdnsClasses} = useGetMsisdnsAPIs()
      const response = await getMsisdnsClasses(this.token);
      if (response.error) {
        alert("Error fetching MSISDN classes: " + response.message);
      } else {
        this.msisdnClasses = response.msisdns_classes;
      }
    },
    editMsisdnClass(msisdnClass) {
      this.selectedMsisdnClass = { ...msisdnClass }; // Clone the object to avoid mutations
      this.isEditing = true;
    },
    async fetchDeleteMsisdnClass() {
      this.openYesNoNotification=false
      const {deleteMsisdnClass} = useGetMsisdnsAPIs()
      const response = await  deleteMsisdnClass(this.token,this.selectedMsisdnClass.id);
      if (response.error) {
        this.showSnackbar("Error fetching MSISDN classes: " + response.message, "error");
      } else {
        this.showSnackbar("MSISDN class deleted", "error");
        this.fetchMsisdnClasses()
      }

    },
    async fetchCancelDeleteMsisdnClass() {
      this.openYesNoNotification=false
        // alert("Delete Canceled")
      this.showSnackbar("Delete Canceled", "danger")
    },
    handleDeleteMsisdnClass(item) {
      // Update the list with the modified class
      this.selectedMsisdnClass=item
      this.openYesNoNotification=true
    },
    handleUpdateSuccess() {
      // Update the list with the modified class
      this.fetchMsisdnClasses()
      this.closeEditor();
      this.closeAddNewMsisdnClass();
      this.showAddNewMsisdnClass=false;
      // alert("Class updated successfully!");
    },
    closeEditor() {
      this.isEditing = false;
      this.selectedMsisdnClass = null;
    },
    closeAddNewMsisdnClass() {
      this.showAddNewMsisdnClass=false;
      this.fetchMsisdnClasses()
      },
  },
  created() {
    const {getLoggedIn, user, loggedIn, userAvatar,token}=useGetLoggedIn()
    getLoggedIn().then(()=> {
      // timestamp("autorizare in HomeloggedIn after getLoggedIn")
      log("dupa created in SelectAvailableMsisdn avem:")
      log("autorizare in  SelectAvailableMsisdn after getLoggedIn")
      log("user:")
      log(user)
      log("loggedIn: " + loggedIn.value)
      log("token: " + token.value)
      log("userAvatar: " + userAvatar)
      this.client_id = user.value.client_id
      this.token = token.value
      this.fetchMsisdnClasses();
    });
  },
};
</script>
